import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';

@Component({
  selector: 'app-mdl-unlink-outlook',
  imports: [],
  templateUrl: './mdl-unlink-outlook.html',
  styleUrl: './mdl-unlink-outlook.css'
})
export class MdlUnlinkOutlook {

  public outlookEmail: string = '';
  private api = inject(Api);

  constructor(
    public dialogRef: MatDialogRef<MdlUnlinkOutlook>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.outlookEmail = data?.email || '';
  } 

  unlinkOutlook() {
    this.api.showLoading();
    this.api.unlinkOutlookAccount({}).subscribe({
      next: (data: any) => {
        this.api.hideLoading();
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.api.hideLoading();
        console.error('Error unlinking Outlook account:', error);
      }
    });
  }

  closeMdl() {
    this.dialogRef.close();
  }
}
